export const REPORTING_AND_ANALYTICS = {
  FETCH_REPORTING_TRANSACTION_META: 'FETCH_REPORTING_TRANSACTION_META',
  DOWNLOAD_REPORT: 'DOWNLOAD_REPORT',
  FETCH_TRANSACTION_DATA: 'FETCH_TRANSACTION_DATA',
  SET_SELECTED_DATE_RANGE: 'SET_SELECTED_DATE_RANGE',
  SET_REPORTING_TRANSACTION_META: 'SET_REPORTING_TRANSACTION_META',
  SET_TRANSACTION_REPORT_FILTERS: 'SET_TRANSACTION_REPORT_FILTERS',
  SET_SELECTED_TIME_RANGE: 'SET_SELECTED_TIME_RANGE',
  SET_SELECTED_FILTERS: 'SET_SELECTED_FILTERS',
  SET_IS_LOADING: 'SET_IS_LOADING',
  SET_ERROR_MESSAGE: 'SET_ERROR_MESSAGE',
  RESET_REPORTING_STATE: 'RESET_REPORTING_STATE',
  SET_CLAIM_STATUS: 'SET_CLAIM_STATUS',
  SET_CONFIG_PAYER: 'SET_CONFIG_PAYER',
  SET_DATE_RANGE_CLICKED: 'SET_DATE_RANGE_CLICKED',
  SET_REPORTING_CONFIG: 'SET_REPORTING_CONFIG',
  FETCH_REPORTING_CONFIG: 'FETCH_REPORTING_CONFIG',
  SHOW_REQUEST_REPORT_MODAL: 'SHOW_REQUEST_REPORT_MODAL',
  REPORTING_DATE_RANGE : 'REPORTING_DATE_RANGE',
  REPORTING_DATE_RANGE_APPLIED: 'REPORTING_DATE_RANGE_APPLIED',
  EXPORT_REPORT_DATA: 'EXPORT_REPORT_DATA',
  CLEAR_STATE: 'CLEAR_STATE',
  FETCH_TAT_DATA: 'FETCH_TAT_DATA',
  RESET_BTN_CLICKED: 'RESET_BTN_CLICKED',
};
